export const EDIT_LEGAL_DOCUMENTS_CHECKS_CLAIM = "CanEditLegalDocumentsChecks";
